import { Component, type OnInit } from '@angular/core'
import {
  IconService,
  TransifexService
} from '@inside-hub-app/customer-portal-shared'
import { type B2CConfig } from '@inside-hub-app/customer-portal-config'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { TranslateService } from '@ngx-translate/core'
import { NGXLogger } from 'ngx-logger'
import { combineLatest } from 'rxjs'
import packageJson from '../../package.json'
import { KcDataService } from './kc-data.service'
import { type KcClientType, type KcLocaleData } from './interfaces/kc-data.interface'
@Component({
  selector: 'customer-portal-kc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'customer-portal-keycloak-forms'
  view = ''
  public isWebWidget: boolean

  public localeData: KcLocaleData

  public appVersion = packageJson.version
  showTransifexSpinner = true

  sub = {
    transifexLanguageIsLoading: null,
    onKcDataLoaded: null,
    combineLatest: null
  }

  constructor (
    private readonly kcDataService: KcDataService,
    private readonly logger: NGXLogger,
    private readonly translate: TranslateService,
    private readonly transifexService: TransifexService,
    private readonly iconService: IconService,
    private readonly remoteConfigService: EfRemoteConfigurationService<B2CConfig>
  ) {
    this.transifexService.initializeTransifex(
      this.remoteConfigService.get('transifexConfig.token')
    )
  }

  ngOnInit (): void {
    this.iconService.registerIcons()

    this.translate.addLangs(
      this.remoteConfigService.get('b2c.supportedLanguages')
    )

    this.sub.transifexLanguageIsLoading = this.transifexService.transifexLanguageIsLoading.subscribe((loading) => {
      this.showTransifexSpinner = loading
    })

    this.setTransifexLanguage()

    this.sub.onKcDataLoaded = this.kcDataService.onKcDataLoaded.subscribe(kcData => {
      this.localeData = this.kcDataService.getLocaleData()
      if (this.localeData != null) {
        const lang = this.localeData.current.substr(0, 2).toLowerCase()
        this.translate.setDefaultLang(
          lang ?? this.remoteConfigService.get('b2c.defaultLanguage')
        )

        this.logger.debug(
          'customer-portal-keycloak-forms Version: ',
          this.appVersion
        )

        this.title = this.kcDataService.getTitle()
        this.view = this.kcDataService.getView()
        this.logger.debug('view: ', this.view)
      }
      this.isWebWidget = this.isExternalLoginWidget(kcData.clientData.clientId)
    })
  }

  setTransifexLanguage (): void {
    this.sub.combineLatest = combineLatest([
      this.kcDataService.onKcDataLoaded,
      this.transifexService.onTransifexInitialized
    ]).subscribe(res => {
      const localeData = this.kcDataService.getLocaleData()
      const transifex = res[1]

      if (localeData != null && transifex) {
        const lang = localeData.current.substr(0, 2).toLowerCase()
        this.transifexService.setLanguage(
          lang ?? this.remoteConfigService.get('b2c.defaultLanguage'),
          this.remoteConfigService.get('transifexConfig.transifexLanguages'),
          this.remoteConfigService.get('country.code')
        )
      }
    })
  }

  isExternalLoginWidget (kcClient: KcClientType): boolean {
    return (kcClient === 'ef-web')
  }
}
